export const PAYMENT_TYPE = {
  MONTH: "month",
  YEAR: "year",
  CANCEL: "cancel",
};
export const MONTH_PRICE = 10000;
export const TAX = 10;

export const YEAR_PRICE = 7500;
